import { CharacterData } from "../../../../utils/game/character/CharacterData";
import TabletopToken from "./TabletopToken";
import TabletopViewport from "../TabletopViewport";

export default class TabletopCharacterToken extends TabletopToken {
    private _characterData: CharacterData | null;

    public constructor(args?: {
        x?: number | (() => number);
        y?: number | (() => number);
        width?: number | (() => number);
        height?: number;
        imgSrc?: string;
        characterData?: CharacterData;
    }) {
        super({
            x: args?.x,
            y: args?.y,
            width: args?.width,
            height: args?.height,
            imgSrc: args?.imgSrc,
        });

        this._characterData = args?.characterData ?? null;
    }

    public get characterData(): CharacterData | null {
        return this._characterData;
    }
    public set characterData(val: CharacterData | null) {
        this._characterData = val;
    }

    public override draw(
        ctx: CanvasRenderingContext2D,
        viewport: TabletopViewport,
        timestamp: number,
    ) {
        super.draw(ctx, viewport, timestamp);

        if (this.showLabel) {
            if (this._characterData != null) {
                const label = this._characterData.name;
                const point = viewport.universePointToViewportPoint(
                    this.topLeft,
                );

                ctx.lineWidth = 2;
                ctx.strokeStyle = "white";
                ctx.fillStyle = "black";
                ctx.font = "bold 16px sans-serif";
                ctx.strokeText(
                    label,
                    point.x +
                        (this.width * viewport.magnificationX) / 2 -
                        ctx.measureText(label).width / 2,
                    point.y - 20,
                );
                ctx.fillText(
                    label,
                    point.x +
                        (this.width * viewport.magnificationX) / 2 -
                        ctx.measureText(label).width / 2,
                    point.y - 20,
                );
            }
        }
    }
}
